import { render, staticRenderFns } from "./Passwordform.vue?vue&type=template&id=1e432bb6&"
import script from "./Passwordform.vue?vue&type=script&lang=js&"
export * from "./Passwordform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports